import { Box, CircularProgress, Typography } from "@mui/material";
import MapIcon from "@mui/icons-material/Map";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import React, { useCallback, useEffect, useState } from "react";
import { getOrderDistribution } from "../../../../api/DeliveryAnalyticsService";

export const OrderDistributionChart = ({ startDate, endDate }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadData();
  }, [loadData, startDate, endDate]);

  const loadData = useCallback(async () => {
    if (!startDate || !endDate) return;

    setLoading(true);
    setError(null);

    try {
      // Create params object for API calls
      const params = {
        start_date: startDate,
        end_date: endDate,
      };

      // Call the stats API
      const response = await getOrderDistribution(params);

      // Set stats data directly from API response
      setData(response.data);
    } catch (err) {
      console.error("Error loading order stats data:", err);
      setError("Não foi possível carregar os dados de pedidos");
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 300,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <MapIcon sx={{ mr: 1, color: "primary.main" }} />
        <Typography variant="h6">
          Distribuição de Pedidos por Região e Horário
        </Typography>
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Análise da concentração de entregas por bairro e horário do dia
      </Typography>

      <Box sx={{ height: 400 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 60,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="region"
              angle={-45}
              textAnchor="end"
              height={70}
              interval={0}
            />
            <YAxis />
            <Tooltip
              formatter={(value) => [`${value} pedidos`, "Quantidade"]}
              labelFormatter={(value) => `Região: ${value}`}
            />
            <Legend />
            <Bar
              name="Manhã (6h-12h)"
              dataKey="morning"
              stackId="a"
              fill="#8884d8"
            />
            <Bar
              name="Tarde (12h-18h)"
              dataKey="afternoon"
              stackId="a"
              fill="#82ca9d"
            />
            <Bar
              name="Noite (18h-00h)"
              dataKey="evening"
              stackId="a"
              fill="#ffc658"
            />
            <Bar
              name="Madrugada (00h-6h)"
              dataKey="night"
              stackId="a"
              fill="#ff8042"
            />
          </BarChart>
        </ResponsiveContainer>
      </Box>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mt: 2, textAlign: "center" }}
      >
        Total de regiões atendidas: {data.length}
      </Typography>
    </>
  );
};
